(function () {
  const STORAGE_KEY = 'rv_products';
  const MAX_PRODUCTS = 10;

  const productDataEl = document.querySelector('[id^="rv-product-data-"]');
  if (!productDataEl) return;

  let current;
  try {
    current = JSON.parse(productDataEl.textContent);
  } catch (e) { return; }

  let viewed = [];
  try {
    viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (!Array.isArray(viewed)) viewed = [];
  } catch (e) { viewed = []; }

  // Verwijder huidig product als het al in de lijst staat
  viewed = viewed.filter(p => p && p.id !== current.id);

  // Voeg toe aan het begin
  viewed.unshift(current);

  // Beperk tot max
  viewed = viewed.slice(0, MAX_PRODUCTS);

  localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
})();

